import { defineMessages } from "react-intl";

export default defineMessages({
  close: {
    id: "close",
    defaultMessage: "close"
  },
});